import { useMemo } from 'react';

import { useGetEmployeeDocuments } from '~/data/documents';
import { Enum, EnumListKey, useAllEnums } from '~/data/enums';
import { useSelectedEmployeeId } from '~/hooks/employee';
import {
  DocumentsEntry,
  convertDocumentTypeToDocumentsEntry,
} from '~/scenes/PeopleModule/components/Tabs/DocumentsTab/DocumentsTable/data';

type UseReadOnlyDocumentsTableOutput = {
  isLoading: boolean;
  selectedEmployeeId: number;
  documentTypes: Enum[];
  documents: DocumentsEntry[];
};

export const useReadOnlyDocumentsTable =
  (): UseReadOnlyDocumentsTableOutput => {
    const { selectedEmployeeId } = useSelectedEmployeeId();
    const { data: readOnlyDocumentsData, isLoading } = useGetEmployeeDocuments({
      employeeId: selectedEmployeeId,
      includeReadOnly: true,
    });

    const { getEnums } = useAllEnums();
    const { documentTypes } = useMemo(() => {
      return {
        documentTypes: getEnums(EnumListKey.DOCUMENT_RESERVED_TYPE),
        // documentApprovalStatuses: getEnums(EnumListKey.DOCUMENT_APPROVAL_STATUS),
      };
    }, [getEnums]);

    const { documents } = useMemo(() => {
      return {
        documents: readOnlyDocumentsData
          .map(convertDocumentTypeToDocumentsEntry)
          .filter((e) => e.readOnly),
      };
    }, [readOnlyDocumentsData]);

    return { isLoading, selectedEmployeeId, documents, documentTypes };
  };
